<template>
  <div>
    <v-dialog
      v-for="(dialog, index) in stack"
      :key="index"
      :value="true"
      :max-width="dialog.maxWidth || 800"
      :persistent="Boolean(dialog.persistent)"
      :fullscreen="Boolean(dialog.fullscreen)"
      :scrollable="dialog.scrollable !== false"
      @input="$event ? undefined : closeDialog()"
    >
      <component
        :is="dialog.component"
        v-test-id="`dialog-component-${index}`"
        v-bind="dialog.attrs || {}"
        v-on="dialog.on || {}"
      />
    </v-dialog>
  </div>
</template>

<script>
import { kebabCase } from 'lodash';
import { mapMutations, mapState } from 'vuex';
import DialogLoading from '../dialog-loading';

const asyncComponent = (name) => {
  const componentFolderName = kebabCase(name);

  return {
    // Keep extension to avoid build test files
    component: import(`~/components/dialogs/${componentFolderName}/index.vue`),
    loading: DialogLoading,
  };
};

const generateAsyncComponents = names => names.reduce((accumulator, name) => {
  accumulator[name] = () => asyncComponent(name);
  return accumulator;
}, {});

export const availableDialogs = [
  'DialogAddHelperText',
  'DialogAddRowInViewWithFiltersWarning',
  'DialogConfirmAction',
  'DialogCreateLinkFieldInfoComponent',
  'DialogCreateOrEditCategory',
  'DialogCreateOrEditField',
  'DialogCreateOrEditInfoComponent',
  'DialogCreateOrEditToken',
  'DialogCreateSymmetricLink',
  'DialogCreateSyncFormSubmitWorkflow',
  'DialogEditCategories',
  'DialogEditChecklistItems',
  'DialogEditMarkdownContent',
  'DialogEditSelectedField',
  'DialogEditViewFields',
  'DialogEditViewFilters',
  'DialogEditViewPermissions',
  'DialogEditViewRecordTemplate',
  'DialogEditViewShareOptions',
  'DialogEditViewSortBy',
  'DialogExpandHistory',
  'DialogFeedback',
  'DialogIntegrationMatches',
  'DialogNewGroup',
  'DialogNewSheet',
  'DialogNewView',
  'DialogNewWorkflow',
  'DialogNextStepsNewView',
  'DialogRecord',
  'DialogRename',
  'DialogRenameInfoComponent',
  'DialogRuntimeOverride',
  'DialogSelectField',
  'DialogUploadFile',
  'DialogWorkflowResource',
];

export default {
  name: 'TheDialog',
  components: generateAsyncComponents(availableDialogs),
  computed: {
    ...mapState('dialog', ['stack']),
  },
  methods: {
    ...mapMutations('dialog', ['closeDialog']),
  },
};
</script>
